import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ITab } from 'src/app/shared/tabs/i-tab';

@Component({
  standalone: false,
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent implements OnInit {

  @Input() tabs: ITab[] = [];

  @Input() activeTab: ITab;

  @Output() closeTab$ = new EventEmitter<ITab>();

  @Output() tabClick$ = new EventEmitter<ITab>();

  constructor() {}

  ngOnInit() {
  }

  onCloseTab(tab) {
    this.closeTab$.emit(tab);
  }

  onTabClick(tab) {
    this.tabClick$.emit(tab);
  }

}
